/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InPerson/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function InPerson({
  children,
  viewPath = "/App/Widget/Content/Questions/Complete/Booking/InPerson"
  
}) {
let constantData = 'Your in-person appointment is confirmed for '
let selectedAnswersAppointmentDisplaydateValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers.appointment.displayDate',
})
let constantData1 = ' at '
let selectedAnswersAppointmentDisplaytimeValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers.appointment.displayTime',
})
let constantData2 = '.'
let aggregateData = fromAggregate.joinNoSpace(constantData, selectedAnswersAppointmentDisplaydateValueData, constantData1, selectedAnswersAppointmentDisplaytimeValueData, constantData2)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 text="We can't wait to see you!"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 data="'Your in-person appointment is confirmed for '"
 data="selected.answers.appointment.displayDate"
 data="' at '"
 data="selected.answers.appointment.displayTime"
 data="'.'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 size="large"
 text="You will receive a confirmation for the appointment soon."
/>
{children}
</React.Fragment>)
}